export * from './lib/platform-root.module';
